import { RestClient } from "clients/rest";
import { PageableResponse } from "../PageableResponse";

export type B080060FindRequest = { shukashijiYmdFrom: string } & Partial<{
  shukashijiYmdTo: string;
  shijikaisu: string;
  batchNo: string;
  shukajokyo: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B080060FindResponse = {
  shukashijiYmd: string;
  shijikaisu: string;
  batchNo: string;
  batchNm: string;
  tenposu: string;
  shohinsu: string;
  denpyomaisu: string;
  shukajokyo: number;
  cancelKbn: number;
  suryoteisei: number;
};

//検索処理
export const B080060Find = (props: B080060FindRequest) => {
  return RestClient.get<PageableResponse<B080060FindResponse[]>>(
    "b080060/find",
    {
      params: props,
    }
  );
};

export type B080060UpdateDetailRequest = Partial<{
  shukashijiYmd: string;
  shijikaisu: string;
  batchNo: string;
  version: string;
}>;

export type B080060UpdateRequest = {
  shukabatchList: B080060UpdateDetailRequest[];
};

//更新処理
export const B080060Update = (props: B080060UpdateRequest) => {
  return RestClient.put("b080060/update", props);
};

export type B080060CheckRequestList = {
  shukabatchList: B080060CheckDetailRequest[];
};

export type B080060CheckDetailRequest = {
  shukashijiYmd: string;
  shijikaisu: string;
  batchNo: string;
};

export type B080060CheckResponse = {
  hikiateCheckFlg: boolean;
  hikiateWarnMessage: string;
  toriokiCheckFlg: boolean;
  toriokiWarnMessage: string;
};

// 明細部データチェック処理
export const B080060Check = (props: B080060CheckRequestList) => {
  return RestClient.post("b080060/check", props);
};
